import { pluginId } from '../pluginId';

export const getTrad = (id: string) => `${pluginId}.${id}`;
